import { useCallback, useMemo, useState } from 'react'
import { clear as clearDb, createStore, del, get, set } from 'idb-keyval'

const useCache = (key, dbName = 'give-cache', storeName = 'give-store') => {
  const store = useMemo(() => createStore(dbName, storeName), [dbName, storeName])
  const [error, setError] = useState(null)

  const getItem = useCallback(async () => {
    if (!store) return null
    try {
      const result = await get(key, store)
      setError(null)
      return result
    } catch (err) {
      setError(err)
      return null
    }
  }, [key, store])

  const setItem = useCallback(
    async (value) => {
      if (!store) return
      try {
        await set(key, value, store)
        setError(null)
      } catch (err) {
        setError(err)
      }
    },
    [key, store]
  )

  const removeItem = useCallback(async () => {
    if (!store) return
    try {
      await del(key, store)
      setError(null)
    } catch (err) {
      setError(err)
    }
  }, [key, store])

  const clear = useCallback(async () => {
    if (!store) return
    try {
      await clearDb(store)
      setError(null)
    } catch (err) {
      setError(err)
    }
  }, [store])

  return { error, clear, getItem, removeItem, setItem }
}

export default useCache
